module.exports = __webpack_public_path__ + "static/media/img3.c2d820b0.jpg";